
import Vue from 'vue';
import Tooltip from './tooltip';
import message from './message';
import messageBox from './message-box';
import 'element-ui/lib/theme-chalk/index.css';
import {
  Popconfirm,
  Avatar,
  Breadcrumb,
  BreadcrumbItem,
  Pagination,
  Dialog,
  Menu,
  Input,
  Option,
  Button,
  Table,
  TableColumn,
  Form,
  FormItem,
  Icon,
  Row,
  Col,
  Card,
  Container,
  Header,
  Aside,
  Main,
  Footer,
  Link,
  Image,
  Loading,
  Drawer,
  MenuItem,
  Tabs,
  TabPane,
  Checkbox,
  Select,
  Timeline,
  TimelineItem,
  Descriptions,
  DescriptionsItem,
  DatePicker,
  TimeSelect,
  TimePicker,
  Popover,
  Badge,
  Collapse,
  CollapseItem,
  Progress,
  Scrollbar,
  CarouselItem,
  Carousel,
  RadioGroup,
  Radio,
  Divider,
  Notification,
  Slider,
  ColorPicker,
  InputNumber
} from 'element-ui'
// import { Slider as ElSlider } from 'element-ui'

Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Drawer)
Vue.use(Popconfirm)
Vue.use(Avatar)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Input)
Vue.use(Option)
Vue.use(Button)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Icon)
Vue.use(Row)
Vue.use(Col)
Vue.use(Card)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Link)
Vue.use(Image)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Checkbox)
Vue.use(Select)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Descriptions)
Vue.use(DescriptionsItem)
Vue.use(DatePicker)
Vue.use(TimeSelect)
Vue.use(TimePicker)
Vue.use(Popover)
Vue.use(Badge)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Tooltip)
Vue.use(Progress)
Vue.use(Scrollbar)
Vue.use(CarouselItem)
Vue.use(Carousel)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Divider)
Vue.use(Slider)
Vue.use(ColorPicker)
Vue.use(InputNumber)

Vue.use(Loading.directive)

Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = messageBox
Vue.prototype.$alert = messageBox.alert
Vue.prototype.$confirm = messageBox.confirm
Vue.prototype.$prompt = messageBox.prompt
Vue.prototype.$notify = Notification
Vue.prototype.$message = message
